module.exports = __webpack_public_path__ + "imgs/DrugPolicyAlliance.15d042148f76aafa8fb855e56c805472.png";